<template>
	<!-- 审核管理 - 我发起的 -->
	<content-view class="initiated">
		<div slot="header">
			<a-form :form="form" layout="inline" class="store-one-form">
				<a-form-item label="审核类型：">
					<a-select v-decorator="['source']" placeholder="请选择" allowClear @select="search">
						<!-- <a-select-option :value="1">票劵退款审批</a-select-option>
						<a-select-option :value="2">出库审批</a-select-option>
						<a-select-option :value="3">调拨审批</a-select-option> -->
						<a-select-option value="REFUND">票券退款</a-select-option>
						<!-- <a-select-option :value="6">营销订单审批</a-select-option>
						<a-select-option :value="7">仓储中心出库审批</a-select-option>
						<a-select-option :value="8">仓储中心调拨审批</a-select-option>
						<a-select-option :value="9">仓储中心商品删除审批</a-select-option> -->
					</a-select>
				</a-form-item>
				<a-form-item label="审核状态：">
					<a-select
						v-decorator="['state']"
						placeholder="请选择"
						allowClear
						@select="search"
					>
						<a-select-option value="0">审批中</a-select-option>
						<a-select-option value="1">审批通过</a-select-option>
						<a-select-option value="-1">审批不通过</a-select-option>
						<a-select-option value="-2">已撤回</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item class="wrap-header-button">
					<a-button class="mr8" type="primary" @click="search">筛选</a-button>
					<a-button @click="handleReset">重置</a-button>
				</a-form-item>
			</a-form>
		</div>
		<div class="wrap-container-in">
		<a-table
			bordered
			:dataSource="dataSource"
			:columns="columns"
			:pagination="pagination"
			@change="changePage"
			:rowKey="record => record.id"
			:loading="loading"
		>
			<template slot="index" slot-scope="text,record,index">{{index+1}}</template>
			<template slot="submitTime" slot-scope="submitTime">{{submitTime && submitTime.replace('T', ' ')}}</template>
			<template slot="approvalTime" slot-scope="approvalTime">{{approvalTime ? approvalTime.replace('T', ' ') : "-"}}</template>
			<template slot="source">
				票券退款
			</template>
			<template slot="state" slot-scope="text">
				{{$utils.auditState[String(text)]}}
			</template>
			<template slot="action" slot-scope="record">
			<a v-if="getBtnByAuth('initiateDetail')" class="text-primary" @click="showModal(record)">查看详情</a>
			</template>
		</a-table>
		</div>
		<order-refund ref="refundOrder" @changeVisibleRefund="changeVisibleRefundOrder" :verifyId="verifyId" :businessId="businessId" :visibleRefund="visibleOrderRefundOrder" :isVerify="false"></order-refund>
	</content-view>
</template>

<script type="text/javascript">
    import orderRefund from "@/components/modules/audit/order-refund.component";
//  默认表头
const columns = [
	{
		title: "序号",
		scopedSlots: { customRender: "index" }
	},
	{
		title: "发起审核类型",
		dataIndex: "source",
		scopedSlots: { customRender: "source" }
	},
	{
		title: "审核人",
		dataIndex: "reviewerName"
	},
	{
		title: "审核状态",
		dataIndex: "state",
		scopedSlots: { customRender: "state" }
	},
	{
		title: "发起时间",
		dataIndex: "submitTime",
		scopedSlots: { customRender: "submitTime" }
	},
	{
		title: "审核时间",
		dataIndex: "approvalTime",
		scopedSlots: { customRender: "approvalTime" }
	},
	{
		title: "操作",
		scopedSlots: { customRender: "action" }
	}
];

export default {
	/**
   * @columns 页面数据表的表头
   * @dataSource 页面数据表的数据
   * @pagination 页面数据表的分页器参数
   * @visibalRefund 退款弹窗渲染条件
   * @visibleOA 出库调拨弹窗渲染条件
   * @visibleOATitle 出库调拨弹窗标题
   */
	name: "initiate",
	components: {
		orderRefund,
	},
	props: {},
	data() {
		const source = {
			REFUND: "票券退款"
		}
		return {
			source,
			columns,
			dataSource:[],
			pagination: {
				showTotal: total => `共 ${total} 条数据`,
				showQuickJumper: true,
				showSizeChanger: true,
				total: 0,
				current:1,
				pageSize: 20,
			},
			visibleRefund: false,
			loading:false,
			verifyId: '',
			businessId: '',
			visibleOrderRefundOrder: false,
			visibleOrderRefundTicket: false,
		};
	},
	computed: {},
	methods: {
		// 表格控件操作回调
		/**
		 * @pagination 表格分页器操作回调的分页参数
		 * @filters 表格筛选操作回调的参数
		 * @sorter 表格排序操作回调的参数
		 */
		changePage(page) {
		this.pagination.pageSize = page.pageSize
		this.pagination.current = page.current
		this.getList();      
		},

		handleReset () {
			this.form.resetFields();
			this.search();
		},
		search() {
			this.pagination.current = 1;
			this.getList();
		},
		// 获取审核管理我发起的表格数据
		/**
		 * @validateFields 表格提交事件监听回调
		 * @body 接口请求参数 
		 * @pageNum 查询数据的目标页码 
		 * @pageSize 查询数据的一页条数 
		 * @state 查询数据状态
		 * @type 查询数据类型
		 */
		getList () {
			this.form.validateFields((err, values) => {
				if (!err) {
					this.loading = true;
					this.$api.audit.listByMe({
						body:{
							pageNum: this.pagination.current,
							pageSize: this.pagination.pageSize,
							state: values.state,
							source: values.source,
						}
					}).then(data => {
						this.dataSource = data.list;
						this.pagination.total = data.total;
						this.loading = false;
					}).catch( err => {
						this.loading = false;
					})
				}
			});
		},
    
    // 显示弹窗
    /**
     * @record 表格数据的单条数据
     * @type 表格数据的单条数据的类型
     */
    showModal (record) {
		this.source = record.source
		switch (record.source){
			case 1:
				//票券退款详情
				/**
				 * @id {number} 审批id
				 */
				this.visibleOrderRefundTicket = true;
				this.verifyId = record.id.toString();
				this.businessId = record.businessId;
				break;
			case 2 :
				//商品出库详情
				this.visibleOATitle="商品出库申请";
				this.OAColumns=OutColumns;
				/**
				 * @id {number} 审批id
				 */
				this.$api.audit.storeOut({
					params:{id:record.id}
				}).then((res) => {
					this.OAdataSource=res;
					this.visibleOA=true;
				})
				break;
			case 3 :
				//商品调拨详情
				this.visibleOATitle="商品调拨申请";
				this.OAColumns=alloColumns;
				/**
				 * @id {number} 审批id
				 */
				this.$api.audit.storeTransfer({
					params:{id:record.id}
				}).then((res) => {
					this.OAdataSource=res;
					this.visibleOA=true;
				})
				break;
			case "REFUND":
				this.visibleOrderRefundOrder = true;
				this.verifyId = record.id.toString()
				this.businessId = record.businessId;
				break; 
			case 6:
				this.visibleOrderRefundOrder = true;
				this.verifyId = record.id.toString()
				this.businessId = record.businessId;
				break; 
			case 7:
				// 仓储中心出库审批
				this.$refs.goodsOutWarehouseApplyDetailModal.showApplyDetail(record);
				break; 
			case 8:
                // 仓储中心调拨审批
				this.$refs.goodsAllocationApplyDetailModal.selfGoodsDispatchInfo(record);
				break; 
			case 9:
				// 仓储中心商品删除审批
				this.$refs.goodsDeleteApplyDetailModal.lookDelGoods(record);
				break; 
		}
    },
	// 打开、关闭订单退款详情弹框
	changeVisibleRefundOrder(val) {
		this.visibleOrderRefundOrder = val.visibleOrderRefundOrder;
		this.isNeedModal = val.isNeedModal;
		this.getList();
	},
	// 打开、关闭票券退款详情弹框
	changeVisibleRefundTicket(val) {
		this.visibleOrderRefundTicket = val
		this.getList();
	},
	},
	beforeCreate() {
		this.form = this.$form.createForm(this);
	},
	created() {},
	mounted() {
			this.getList();
	},
};
</script>
<style lang="scss">
.initiated {
	.wrap-header-button {
		width: auto;
	}
	.ant-modal-footer {
		border-top: 0;
		padding: 8px 0;
		text-align: right;
		border-radius: 0 0 4px 4px;
	}
	&-vip-card {
		background: #fafafa;
		border-radius: 4px;
		border: 1px solid #e9e9e9;
		.text-black-ap65 {
		color: rgba(0, 0, 0, 0.65);
		}
	}
}
</style>